import React from "react";
import DataGridTableAdapter from "./DataGridTableAdapter";
import DiffArrow from "./DiffArrow";

class LeaderBoardTeamAoeItalia extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
  }

  apiUrl = "https://api.aoeitalia.com/v1/match/players?mode=0";

  refreshTable() {
    fetch(this.apiUrl)
      .then((response) => response.json())
      .then((data) => data.data)
      .then((players) =>
        this.setState({
          data: players.sort(function (a, b) { return parseInt(b.elo_aoei) - parseInt(a.elo_aoei) }),
        })
      ).catch(rejected => {
        console.log(rejected);
      });
  }

  componentDidMount() {
    this.refreshTable();
  }

  columns = [
    {
      title: "#",
      type: "numeric",
      sorting: false,
      render: (rowData, row) => {
        return <div> {rowData.tableData.id + 1}</div>
      },
    },
    { title: "Nome", field: "username" },
    {
      title: "Rating",
      field: "elo_aoei",
      type: "numeric",
      defaultSort: "desc",
    },
    {
      title: "",
      type: "numeric",
      sorting: false,
      render: (rowData) => {
        var diff = rowData.elo_aoei - rowData.prev_aoei;
        if (rowData.elo_aoei === 0) {
          return null;
        } else return <DiffArrow diff={diff} />;
      },
    },
    { title: "Max Rating", field: "top_aoei", type: "numeric" },
    { title: "Ultima Striscia", field: "wir_aoei", type: "numeric" },
    { title: "Giocate", field: "games_aoei", type: "numeric" },
    { title: "Vittorie", field: "wins_aoei", type: "numeric" },
    {
      title: "Sconfitte",
      type: "numeric",
      render: (rowData) => {
        return rowData.games_aoei - rowData.wins_aoei;
      },
    },
    { title: "Ultima partita", field: "lastdt_aoei" },
  ];

  render() {
    return (
      <div className="LeaderBoard">
                <DataGridTableAdapter
          columns={this.columns}
          data={this.state.data}
          title=""
          onRefresh={() => this.refreshTable()}
        />
      </div>
    );
  }
}

export default LeaderBoardTeamAoeItalia;
